import { atsApiQuery } from '..';

export const interviewPlanApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getInterviewPools: builder.query({
        providesTags: ['GetInterviewPools'],
        transformResponse: (response) => response?.data,
        query: (params) => {
          const { filter, searchTerm } = params;
          const data = {
            type: 'ats_interviewer_pool',
          };
          if (searchTerm) {
            data.name = searchTerm;
          }
          if (filter === 'archived') {
            data.archived = true;
          }
          return {
            method: 'get',
            url: `/user_groups`,
            params: data,
          };
        },
      }),
      getInterviewPool: builder.query({
        transformResponse: (response) => response?.data,
        query: (params) => {
          const { poolId } = params;
          return {
            method: 'get',
            url: `/user_groups/${poolId}`,
          };
        },
        keepUnusedDataFor: 0,
      }),
      getInterviewPoolById: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { poolId } = payload;
          return {
            method: 'get',
            url: `/user_groups/${poolId}`,
          };
        },
      }),
      createInterviewPool: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params } = payload;
          return {
            method: 'post',
            url: `/user_groups`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetInterviewPools' }];
          }
          return [];
        },
      }),
      cloneInterviewPool: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params, poolId } = payload;
          return {
            method: 'put',
            url: `/user_groups/${poolId}/clone`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetInterviewPools' }];
          }
          return [];
        },
      }),
      updateInterviewPool: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params, poolId } = payload;
          return {
            method: 'put',
            url: `/user_groups/${poolId}`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetInterviewPools' }];
          }
          return [];
        },
      }),
      archiveInterviewPool: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { poolId } = payload;
          return {
            method: 'delete',
            url: `/user_groups/${poolId}`,
          };
        },
        invalidatesTags: () => [{ type: 'GetInterviewPools' }],
      }),
      unArchiveInterviewPool: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { poolId } = payload;
          return {
            method: 'put',
            url: `/user_groups/${poolId}/restore`,
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetInterviewPools' }];
          }
          return [];
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetInterviewPoolsQuery,
  useCreateInterviewPoolMutation,
  useGetInterviewPoolQuery,
  useUpdateInterviewPoolMutation,
  useArchiveInterviewPoolMutation,
  useUnArchiveInterviewPoolMutation,
  useGetInterviewPoolByIdMutation,
  useCloneInterviewPoolMutation,
} = interviewPlanApi;
